// extracted by mini-css-extract-plugin
module.exports = {"variant--input":"Style_variant--input__GXTCE","variant--textarea":"Style_variant--textarea__opmJy"};